import RestClient from './../../service/rest-client';
import {Signal} from 'signals';
import _ from 'underscore'
class Service {

    event = {
        onFetchSourceSeriesStatsByRevenue: new Signal(),
        onFetchCountryForUTMSourceByRevenue: new Signal(),
    };

    fetchCountryForUTMSourceByRevenueDay(intervalDates) {
        intervalDates = intervalDates || 1;

        RestClient.isSessionActive();
        var queryParams = [`interval_days=${ intervalDates }`];

        var urlRequestTemplate = "/reporting/sourcestats/bycountry?" + queryParams.join("&");

        return RestClient.getRequest(urlRequestTemplate,"").then((data) => {
            var page = data.page_number;
            var pageSize = data.page_size,
                offset = (page - 1) * pageSize;
            var pagingMetadata = {
                page: data.page_number,
                startIndex: offset + 1,
                endIndex: offset + pageSize,
                totalCount: data.total_count,
                pageCount: Math.max(Math.ceil(data.total_count / pageSize), 1)//Always 1 page, even if 0 results
            };
            data.pagingMetadata = pagingMetadata;
            data.results = this.parseCountryForUTMSourceByRevenue(data.results);
            this.event.onFetchCountryForUTMSourceByRevenue.dispatch(data);
        }).catch((error) => {
            console.log("Error: " + error);
        });
    }

    parseCountryForUTMSourceByRevenue(resultData) {
        var parsedArray = resultData.map(function(dataItem) {
            var parsedObject = {};
            parsedObject.id = dataItem.id;
            parsedObject.utmsource = (dataItem.utmsource).replace(/first:|last:/gi, '');
            parsedObject.countryName = dataItem.countryName;

            return parsedObject;
        });
        return parsedArray;
    }

    // start country histogram by revenue
    fetchSourceHistogramSeriesStatsByRevenue(intervalDays) {
        RestClient.isSessionActive();
        var queryParams = [`interval_days=${ intervalDays }`];
        var urlRequestTemplate = "/reporting/sourcestats/byrevenue?" + queryParams.join("&");

        return RestClient.getRequest(urlRequestTemplate,"").then( (data) => {
            var chartData = this.parseSeriesData(data.results[0]);
            this.event.onFetchSourceSeriesStatsByRevenue.dispatch(chartData);
        }).catch((error) => {
            console.log("Error: " + error);
        });
    }

    parseSeriesData(resultData) {
        var chartData = {
            categoryList : [],
            revenueSeriesData: [],
            signUpSeriesData: [],
            packageSeriesData: [],
            shipmentSeriesData: [],
            newPackageSeriesData: [],
            newShipmentSeriesData: [],
        };

        chartData.categoryList = _.map(resultData.graphCategoryList, function(dataItem)
            { return dataItem.replace(/first:|last:/gi, ''); }
        );
        resultData.revenueSeries.forEach(function(dataItem) {
            chartData.revenueSeriesData.push(dataItem.revenue);
        });

        resultData.signUpSeries.forEach(function(dataItem) {

            chartData.signUpSeriesData.push(dataItem.signUpCount);
        });

        resultData.packageSeries.forEach(function(dataItem) {
            chartData.packageSeriesData.push(dataItem.packageCount);
            chartData.newPackageSeriesData.push(dataItem.newPackagesCount);
        });

        resultData.shipmentSeries.forEach(function(dataItem) {
            chartData.shipmentSeriesData.push(dataItem.shipmentCount);
            chartData.newShipmentSeriesData.push(dataItem.newShipmentsCount);
        });

        return chartData;
    }
}

export default new Service();